import React, { Fragment } from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { StaticQuery, graphql, Link } from 'gatsby'
import { layouts, zIndex } from '@/utils/preset'
import { desktop, laptop, tablet, tabletL, tabletS, mobile } from '@/utils/media'
import { mq } from '@/utils/helpers'
import Typography from './Typography'
import Nav from './Nav'
import NavMenu from './NavMenu'
import LogoButton from './LogoButton'

const Header = () => (
  <Root>
    <Container>
      <LogoButton to="/" component={Link} css={styles.LogoButton} type="contrast"/>
      <Catch variant="body3">神奈川県の小さなオフィスから<br />受託開発を始めて20年。</Catch>
      <Spacer />
      <StaticQuery
        query={query}
        render={ data => {
          const routes = data.routes.edges[0].node
          const offices = data.offices.edges.map(el => el.node)
          return (
            <Fragment>
              <Nav offices={offices} routes={routes} css={styles.Nav}></Nav>
              <NavMenu routes={routes} css={styles.NavMenu}/>
            </Fragment>
          )
        }}
      />
    </Container>
  </Root>
)

export default Header

const Root = styled.header`
  display: flex;
  color: white;
  position: relative;
  @media ${mq.and(desktop, laptop, tabletL)} {
    z-index: 1;
  }
  justify-content: space-between;
`

const Container = styled(layouts.components.Container())`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  @media ${mq.and(tablet)} {
    justify-content: flex-end;
  }
  @media (max-width: ${layouts.defs.maxWidthWithPad}px) {
    width: 100vw;
    max-width: 100vw;
    padding: 0;
  }
`

const Catch = styled(Typography)`
  flex-shrink: 0;
  flex-grow: 0;
  padding: 0 32px;
  @media ${mq.and(desktop)} {
    br {
      display: none;
    }
  }
  @media ${mq.and(tablet, mobile)} {
    display: none;
  }
`

const Spacer = styled.div`
  flex-shrink: 1;
  flex-grow: 1;
`

const styles = {
  LogoButton: css`
    @media ${mq.and(tabletS, mobile)} {
      z-index: ${zIndex.nav.base};
      position: fixed;
      top: 0;
      left: 0;
      width: 64px;
      height: 64px;
    }
    @media (max-width: ${mobile.max}px) and (min-width: ${layouts.defs.mobileMaxWidth + layouts.defs.pad.mobile * 2}px) {
      left: calc((100vw - ${layouts.defs.mobileMaxWidth}px) / 2);
    }
  `,
  Nav: css`
    flex-shrink: 0;
    flex-grow: 0;
    min-width: 50%;
  `,
  NavMenu: css`
    @media ${mq.and(desktop, laptop, tabletL)} {
      display: none;
    }
  `
}

const query = graphql`
  query HeaderQuery {
    routes: allRouteYaml {
      edges {
        node {
          main {
            title
            path
            description
            childLists {
              title
              path
            }
          }
          conversion {
            title
            path
            type
          }
          others {
            title
            childLists {
              title
              path
            }
          }
        }
      }
    }
    offices: allCompanyOfficeListYaml {
      edges {
        node {
          area
          headquarter
          postalCode
          address
          tel
          fax
          access
        }
      }
    }
  }
`
